export const ADD_MAIL_TEMPLATE: string = "ADD_MAIL_TEMPLATE";
export const CLEAR_MAIL_TEMPLATES: string = "CLEAR_MAIL_TEMPLATES";

export function addMailTemplate(template_Id: string, channelId:number,name:string, status:number): IAddMailTemplateActionType {
    return { type: ADD_MAIL_TEMPLATE, template_Id:template_Id, channelId:channelId, name:name, status:status}
}
export function clearMailTemplates(): IClearMailTemplateActionType {
    return { type: CLEAR_MAIL_TEMPLATES};
}
interface IAddMailTemplateActionType { 
    type:string,
    template_Id: string, 
    channelId:number,
    name:string, 
    status:number
}
interface IClearMailTemplateActionType { 
    type:string 
}